exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-item.active .page-link{z-index:1;color:#fff;background-color:#50a5f1}.modal-header .close{display:none}", ""]);

// exports
